module.exports = __webpack_public_path__ + "static/media/13․062.46733c25.webp";